import { get, postSafe } from '@/util/http'

// 更新审计类型
export const updateAuditItem = params => postSafe(`/security/auditItem/update.json`, params, 2)
// 查询类型列表
export const fetchAuditItems = params => get(`/security/auditItem/fetch.json`)
// 重置
export const resetAuditItems = params => postSafe(`/security/auditItem/reset.json`, params, 3)
// 查询审计日志列表
// export const fetchAuditLogs = params => get(`/security/auditLog/fetch.json`, params)
export const fetchAuditLogs = params => get(`/fems/auditLog/find.json`, params)
